module.exports = __webpack_public_path__ + "img/industry-mobility-automotive-public-transportation-aviation_blue.3cff229f.png";